<script setup>
import {ref, onBeforeMount, computed, nextTick} from 'vue'
import YTCard from "@/components/YTCard/newIndex.vue";
import YTRadio from "@/components/YTRadio/index.vue";
import YTAddress from "@/components/YTAddress/index.vue";
import YTAvatarUpload from "@/components/YTAvatarUpload/index.vue";
import {detailTenant, listTenant} from "@/api/user/user.js";
import moment from "moment";
import BoxUpload from "@/components/YTBoxUpload/index.vue";
import {tagsScenarioList} from "@/api/tag/tag.js";
import {listTenantOrganizeNotStoreIdIgnore} from "@/api/tenant/tenant.js";
import YTPartnerSelectPanel from "@/views/tenant/components/YTPartnerSelectPanel/index.vue";
import {getRoute} from "@/hooks/getRoute.js";
import YTEditor from "@/components/YTEditor/index.vue";

const {route} = getRoute()

const props = defineProps({
  // 是否编辑模式
  isEdit: {
    type: Boolean,
    default: false
  },
  // 双向绑定值
  modelValue: {
    required: true,
    type: Object,
  },
})

const emit = defineEmits(['success'])
onBeforeMount(async () => {
  await getSkillTags()
  if (!props.isEdit && route.query.tenantId) {
    // 查询商家信息
    await handleGetTenantDetail(route.query.tenantId)
  }
})

// 处理获取商家详情
const handleGetTenantDetail = async (tenantId) => {
  try {
    loading.value = true
    const res = await detailTenant(tenantId)
    if (!res) return
    ruleForm.value.tenantId = res.tenantId
    ruleForm.value.tenantName = res.name
    ruleForm.value.certificationType = res.certificationType
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = true
  }
}

// 加载状态
const loading = ref(false)

/*商家列表相关*/
// 商家列表
const tenantList = ref([])
// 商家列表加载状态
const tenantLoading = ref(false)
// 商家总数
const totalTenant = ref(0)
// 商家列表当前页数
const pageTenant = ref(1)
// 商家列表页长
const pageSizeTenant = ref(5)
// 处理选择商家改变
const handleTenantChange = (e) => {
  console.log("run in handleTenantChange", handleTenantChange)
  const tenant = tenantList.value.find(item => item.tenantId === e)
  ruleForm.value.tenantId = tenant.tenantId
  ruleForm.value.tenantName = tenant.name
  ruleForm.value.certificationType = tenant.certificationType
}
// 处理商家翻页
const handleChangeTenantPage = (e) => {
  pageTenant.value = e
  handleGetTenantList()
}
// 搜索关键字缓存
const keywordTenant = ref()
// 搜索触发函数
const handleRemoteSearch = (keyword) => {
  keywordTenant.value = keyword
  pageTenant.value = 1
  handleGetTenantList()
}
// 获取商家列表
const handleGetTenantList = async () => {
  tenantLoading.value = true
  const page = {
    page: pageTenant.value,
    pageSize: pageSizeTenant.value,
  }
  let param = {
    keyword: keywordTenant.value || null
  }
  const res = await listTenant(page, param)
  tenantList.value = res.list
  totalTenant.value = parseInt(res.total)
  console.log(res)
  tenantLoading.value = false
}

/*合作身份列表相关*/
// 合作身份列表
const partnerList = ref([])
// 合作身份列表加载状态
const partnerLoading = ref(false)
// 获取合作身份列表
const handleGetPartnerList = async () => {
  partnerLoading.value = true
  let page = {
    page: 1,
    pageSize: 100,
  }
  let param = {
    tenantId: ruleForm.value.tenantId,
    storeId: ruleForm.value.storeId
  }
  const res = await listTenantOrganizeNotStoreIdIgnore(page, param)
  partnerList.value = res.list
  console.log(res)
  partnerLoading.value = false
}
// 处理删除合作身份tags
const handleClosePartnerStoresTags = (index) => {
  console.log("index", index)
  ruleForm.value.partnerStores.splice(index, 1)
}

/*表单相关*/
// 表单锚点
const ruleFormRef = ref()
// 表单信息，实现「双向绑定」
const ruleForm = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val)
})
// 车店logo校验规则
const checkImagesList = (rule, value, callback) => {
  const listLength = boxUploadRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请上传一张车店Logo'))
  }
  callback()
}
// 车店地址校验规则
const checkAddress = (rule, value, callback) => {
  if (!addressCode.value) return callback(new Error("请选择俱车店所在地区"))
  return callback()
}
// 车店详细地址规则校验
const checkAddressAddressDetail =  (rule, value, callback) => {
  if (!ruleForm.value.storeAddress.addressDetail) return callback(new Error("请填写详细地址"))
  if (!ruleForm.value.storeAddress.addressDetailEn) return callback(new Error("请填写详细地址（English）"))
  return callback()
}
// 校验表单 - 营业时间
const checkOperatingHours = (rule, value, callback) => {
  console.log("ruleForm.operatingHours.length < 0", ruleForm.value.operatingHours.length <= 0)
  if (ruleForm.value.operatingHours.length <= 0) {
    return callback(new Error("请添加营业时间"))
  } else {
    console.log("校验规则：", ruleForm.value.operatingHours)
    ruleForm.value.operatingHours.map(item => {
      console.log("开始星期", item.weekdayOpen)
      console.log("开始星期布尔值", Boolean(!item.weekdayOpen))
      if (!item.weekdayOpen) {
        return callback(new Error("有开始星期未选择"))
      }
      if (!item.weekdayClose) {
        return callback(new Error("有结束星期未选择"))
      }
      if (!item.operatingTime[0] || !item.operatingTime[1]) {
        return callback(new Error("有营业时间未选择"))
      }
    })
  }
  return callback()
}
// 校验表单 - 封面图
const checkStoreCover = (rule, value, callback) => {
  if(boxUploadCoverRef.value.fileList.length <= 0) return callback(new Error('请上传至少一张车店封面图'))
  callback()
}
// 校验表单 - 照片列表
const checkPhotoList = (rule, value, callback) => {
  if(boxUploadPhotoRef.value.fileList.length <= 0) return callback(new Error('请上传至少一张车店照片'))
  callback()
}
// 校验表单 - 车店发现页推荐封面图
const checkStoreDiscoverCoverImage = (rule, value, callback) => {
  if(boxUploadStoreDiscoverCoverRef.value.fileList.length <= 0) return callback(new Error('请上传至少一张车店发现页推荐封面图'))
  callback()
}
// 简介校验规则
const checkSummary =  (rule, value, callback) => {
  if (!ruleForm.value.summary) return callback(new Error("请填写简介（中文）"))
  if (!ruleForm.value.summaryEn) return callback(new Error("请填写简介（English）"))
  return callback()
}
// 默认校验规则
const rulesOne = {
  storeLogo: [
    {required: true, validator: checkImagesList, trigger: "blur"},
  ],
  name: [
    {required: true, message: "请填写车店名称", trigger: "blur"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  storeAddress: [
    { required: true, validator: checkAddress, trigger: 'change' }
  ],
  addressDetail: [
    {required: true, validator: checkAddressAddressDetail, trigger: "blur"},
  ],
  operatingHours: [
    {required: true, validator: checkOperatingHours, trigger: "blur"},
  ],
  serviceModeTypes: [
    {required: true, message: "请选择服务提供方式", trigger: "blur"},
  ],
  businessTypes: [
    {required: true, message: "请选择服务和商品", trigger: "blur"},
  ],
  summary: [
    // {required: true, validator: checkSummary, trigger: "blur"},
  ],
  contactName: [
    {required: true, message: "请填写负责人", trigger: "change"},
  ],
  phone: [
    {required: true, message: "请填写负责人联系电话", trigger: "blur"},
  ],
  storeCoverImage: [
    {required: true, validator: checkStoreCover, trigger: "blur"},
  ],
  photoList: [
    // {required: true, validator: checkPhotoList, trigger: "blur"},
  ],
  storeDiscoverCoverImage: [
    {required: true, validator: checkStoreDiscoverCoverImage, trigger: "blur"},
  ]
}
// 表单校验规则
const rules = ref(rulesOne)
// 处理协助运营状态修改
const handleAssistStateChange = (state) => {
  if (state === ruleForm.value.assistsOperation) return console.log("点击的与当前值相同，不赋值")
  ElMessageBox.confirm(
      `确认${state ? '开通' : '关闭'}协助运营的权限吗？`,
      '温馨提示',
      {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }
  ).then(() => {
    ruleForm.value.assistsOperation = state
  }).catch((e) => {
    console.log("点击了取消")
  })
}
// 表单校验
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, fields) => {
    if (valid) {
      await createTenantTherapy()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 创建商家车店
const createTenantTherapy = () => {
  // 处理营业时间
  ruleForm.value.operatingHours.map(i => {
    i.operatingStart = moment(i.operatingTime[0]).seconds(0).format('HH:mm:ss')
    i.operatingEnd = moment(i.operatingTime[1]).seconds(0).format('HH:mm:ss')
  })
  console.log("ruleForm", ruleForm.value)
  emit("success")
}
// 缓存省市区code信息
const addressCode = ref()
// 缓存收件地址code信息
const recipientAddressCode = ref()
// 处理选择所属区域
const handleSelectAddress = (data) => {
  ruleForm.value.storeAddress.provinceCode = null
  ruleForm.value.storeAddress.cityCode = null
  ruleForm.value.storeAddress.districtCode = null
  console.log("data:", data)
  addressCode.value = data.value
  ruleForm.value.storeAddress.provinceCode = data.value[0]
  ruleForm.value.storeAddress.cityCode = data.value[1]
  ruleForm.value.storeAddress.districtCode = data.value.length > 2 ? data.value[2] : null
  ruleFormRef.value.validateField("storeAddress")
}
// 处理选择收件地址
const handleSelectRecipientAddress = (data) => {
  ruleForm.value.recipientInfo.recipientAddress.provinceCode = null
  ruleForm.value.recipientInfo.recipientAddress.cityCode = null
  ruleForm.value.recipientInfo.recipientAddress.districtCode = null
  recipientAddressCode.value = data.value
  ruleForm.value.recipientInfo.recipientAddress.provinceCode = data.value[0]
  ruleForm.value.recipientInfo.recipientAddress.cityCode = data.value[1]
  ruleForm.value.recipientInfo.recipientAddress.districtCode = data.value.length > 2 ? data.value[2] : null
}
// 反显省市区code信息
const handleReviewAddressCode = (data) => {
  addressCode.value = data
}
// 反显收件地址code信息
const handleReviewRecipientAddressCode = (data) => {
  recipientAddressCode.value = data
}
// 开始日期星期数组
const startDataOptions = ref([
  {
    label: "周一",
    value: "MONDAY",
  },
  {
    label: "周二",
    value: "TUESDAY",
  },
  {
    label: "周三",
    value: "WEDNESDAY",
  },
  {
    label: "周四",
    value: "THURSDAY",
  },
  {
    label: "周五",
    value: "FRIDAY",
  },
  {
    label: "周六",
    value: "SATURDAY",
  },
  {
    label: "周日",
    value: "SUNDAY",
  }
])

// 添加营业时间
const addOperatingTime = () => {
  ruleForm.value.operatingHours.push({
    weekdayOpen: null,
    weekdayClose: null,
    operatingStart: null,
    operatingEnd: null,
    operatingTime: []
  })
}
// 删除已填写的营业时间
const removeOperatingTime = (index) => {
  console.log("index", index)
  ruleForm.value.operatingHours.splice(index, 1)
  ruleFormRef.value.validateField("operatingHours")
}
// 判断营业结束时间选择范围
const handleWeekdayClose = (item, index) => {
  try {
    const findIndex = startDataOptions.value.findIndex(i => i.value === item.weekdayOpen)
    return index < findIndex
  } catch (e) {
    console.log(e)
    return false
  }
}
// 处理更改营业开始时间清空营业关闭时间
const handleClearClose = (index) => {
  ruleForm.value.operatingHours[index].weekdayClose = null
}

/*上传图片组件相关*/
// Logo图片上传组件锚点
const boxUploadRef = ref();
// 场地封面图上传组件锚点
const boxUploadCoverRef = ref();
// 场地照片上传组件锚点
const boxUploadPhotoRef = ref();
// 场地发现页推荐封面图组件锚点
const boxUploadStoreDiscoverCoverRef = ref()
// 处理Logo图片上传成功
const handlePicSuccess = (url) => {
  ruleForm.value.storeLogo = null;
  ruleForm.value.storeLogo = url[0];
  ruleFormRef.value.validateField("storeLogo");
  loading.value = false;
};
// 处理场地封面图上传成功
const handleCoverPicSuccess = (url) => {
  ruleForm.value.storeCoverImage = null;
  ruleForm.value.storeCoverImage = url[0];
  ruleFormRef.value.validateField("storeCoverImage");
  loading.value = false;
};
// 处理场地照片上传成功
const handlePhotoPicSuccess = (url) => {
  ruleForm.value.photoList = [];
  ruleForm.value.photoList = url;
  ruleFormRef.value.validateField("photoList");
  loading.value = false;
};
// 处理场地发现页推荐封面图上传成功
const handleStoreDiscoverCoverPicSuccess = (url) => {
  ruleForm.value.storeDiscoverCoverImage = []
  ruleForm.value.storeDiscoverCoverImage = url
  ruleFormRef.value.validateField("storeDiscoverCoverImage");
  loading.value = false
}
// 处理Logo图片反显
const handleReviewPic = (reviewList) => {
  boxUploadRef.value.handleReview(reviewList);
};
// 处理场地封面图反显
const handleCoverReviewPic = (reviewList) => {
  boxUploadCoverRef.value.handleReview(reviewList);
};
// 处理场地照片反显
const handlePhotoReviewPic = (reviewList) => {
  boxUploadPhotoRef.value.handleReview(reviewList);
};
// 处理场地发现页推荐封面图反显
const handleReviewStoreDiscoverCoverPic = (reviewList) => {
  boxUploadStoreDiscoverCoverRef.value.handleReview(reviewList);
};
// 处理删除场地封面图
const handleCoverPicRemove = (url) => {
  ruleForm.value.storeCoverImage = url
}
// 处理删除场地照片
const handlePhotoPicRemove = (url) => {
  ruleForm.value.photoList = url
}
// 处理删除场地发现页推荐封面图
const handleStoreDiscoverCoverPicRemove = (url) => {
  ruleForm.storeDiscoverCoverImage = url[0] ? url[0] : null
}

/*标签相关*/
// 驿站标签
const skillTags = ref([])
// 获取驿站特点标签和标签
const getSkillTags = async () => {
  try {
    loading.value = true
    let page = {
      page: 1,
      pageSize: 100,
    }
    const res = await tagsScenarioList(page, {usageScenario: "BIKE_STORE"})
    skillTags.value = res.list
    skillTags.value.map(tag => {
      tag.checked = false
    })
    nextTick(() => {
      // 标签反显兜底
      if (props.isEdit) {
        handleReviewTagList()
      }
    })
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理标签改变
const handleSkillTagsChange = (tag) => {
  console.log("tag", tag)
  tag.checked = !tag.checked
  let temp = []
  skillTags.value.map(i => {
    if (i.checked) temp.push(i.tagId)
  })
  ruleForm.value.tagIdList = temp
  ruleFormRef.value.validateField("tagIdList");
}
// 处理标签反显
const handleReviewTagList = () => {
  skillTags.value.map(i => {
    if (ruleForm.value.tagIdList.includes(i.tagId)) i.checked = true
  })
}

/*中英文切换输入框相关Tab*/
// 俱乐部名称tab
const therapyNameTab = ref("zh")
// 详细地址tab
const addressDetailTab = ref("zh")
// 简介tab
const summaryTab = ref("zh")
// 详细介绍tab
const descriptionTab = ref("zh")

/*车店介绍相关*/
// 车店介绍（中文）富文本锚点
const YTEditorRef = ref()
// 车店介绍（English）富文本锚点
const YTEditorEnRef = ref()
// 处理车店介绍（中文）富文本内容改变
const handleDescriptionChange = (txt, imgArr) => {
  ruleForm.value.description = txt
  ruleForm.value.descriptionImages = imgArr
}
// 处理车店介绍（English）富文本内容改变
const handleDescriptionEnChange = (txt, imgArr) => {
  ruleForm.value.descriptionEn = txt
  ruleForm.value.descriptionEnImages = imgArr
}

/*合作身份面板弹窗相关*/
// 面板锚点
const YTPartnerSelectPanelRef = ref()
// 处理面板打开
const handleOpenPanel = async () => {
  if (!ruleForm.value.tenantId) return ElMessage.error("请先选择所属商家")
  YTPartnerSelectPanelRef.value.handleOpen()
  await handleGetPartnerList()
}
// 处理面板确认
const handlePanelConfirm = (stores) => {
  console.log("stores", stores)
  ruleForm.value.partnerStores = stores
}

defineExpose({
  handleReviewAddressCode,
  handleReviewRecipientAddressCode,
  handleReviewPic,
  handleCoverReviewPic,
  handlePhotoReviewPic,
  handleReviewStoreDiscoverCoverPic,
  handleReviewTagList
})
</script>

<template>
  <div class="create_container_box flex">
    <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        style="height: 100%;width: 100%;"
        class="flex"
        size="large"
    >
      <div class="create_wrapper flex_1">
        <YTCard :title="`基本信息`">
          <template #container>
            <el-form-item prop="storeLogo">
              <YTAvatarUpload :ali-oss-path="'STORE_LOGO'"
                              ref="boxUploadRef"
                              :isReplaceMode="true"
                              :isLogoMode="true"
                              :limit="1"
                              :width="80"
                              :height="80"
                              :file-size="1"
                              :isRequired="true"
                              :tips="``"
                              @progress="loading = true"
                              @success="handlePicSuccess"
              ></YTAvatarUpload>
            </el-form-item>
            <el-form-item label="车店名称：" prop="name">
              <el-tabs
                  v-model="therapyNameTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input style="width: 250px" maxlength="20" show-word-limit v-model="ruleForm.name" placeholder="请输入车店名称"></el-input>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input style="width: 250px" maxlength="60" show-word-limit v-model="ruleForm.nameEn" placeholder="Please enter the name of the organization"></el-input>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item label="所属商家：" prop="tenantId">
              <el-select
                  v-model="ruleForm.tenantId"
                  placeholder="所属商家"
                  size="large"
                  style="width: 240px;"
                  :loading="tenantLoading"
                  @change="handleTenantChange"
                  filterable
                  remote
                  remote-show-suffix
                  :remote-method="handleRemoteSearch"
              >
                <el-option
                    v-for="item in tenantList"
                    :key="`tenantId${item.tenantId}`"
                    :label="item.name"
                    :value="item.tenantId"
                />
                <template v-if="!loading && !tenantList.some(res => res.tenantId === ruleForm.tenantId) && ruleForm.tenantId" #header>
                  当前已选：
                  <el-option
                      :label="ruleForm.tenantName"
                      :value="ruleForm.tenantId"
                  />
                </template>

                <template #footer>
                  <div class="flex_center">
                    <el-pagination
                        size="small"
                        background
                        layout="prev, pager, next"
                        :total="totalTenant"
                        class="mt-4"
                        v-model:current-page="pageTenant"
                        v-model:page-size="pageSizeTenant"
                        @current-change="handleChangeTenantPage"
                    />
                  </div>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="所在地区：" prop="storeAddress">
              <YTAddress ref="YTAddressRef" :title="'所在地区'" :address-code="addressCode" @select="handleSelectAddress"></YTAddress>
            </el-form-item>
            <el-form-item label="详细地址：" prop="addressDetail">
              <el-tabs
                  v-model="addressDetailTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input v-model="ruleForm.storeAddress.addressDetail" style="width: 250px;" placeholder="详细地址"/>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input v-model="ruleForm.storeAddress.addressDetailEn" style="width: 250px;" placeholder="Detailed address"/>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item label="营业时间：" prop="operatingHours">
              <div>
                <div class="flex_center mg_b_1" v-for="(item, index) in ruleForm.operatingHours" :key="`operatingHours${index}`">
                  <div class="flex">
                    <el-select
                        v-model="item.weekdayOpen"
                        placeholder="开始星期"
                        size="large"
                        style="width: 120px"
                        class="mg_r_1"
                        @change="handleClearClose(index)"
                    >
                      <el-option
                          v-for="opt in startDataOptions"
                          :key="opt.value"
                          :label="opt.label"
                          :value="opt.value"
                      />
                    </el-select>
                    <span class="mg_r_1">至</span>
                    <el-select
                        v-model="item.weekdayClose"
                        placeholder="结束星期"
                        size="large"
                        style="width: 120px"
                        class="mg_r_1"
                        :disabled="item.weekdayOpen === null"
                    >
                      <el-option
                          v-for="(opt, optIndex) in startDataOptions"
                          :key="opt.value"
                          :label="opt.label"
                          :value="opt.value"
                          :disabled="handleWeekdayClose(item, optIndex)"
                      />
                    </el-select>
                  </div>
                  <div class="flex mg_r_1">
                    <el-time-picker format="HH:mm" class="mg_r_1" style="max-width: 150px" v-model="item.operatingTime[0]" placeholder="营业开始时间" />
                    <div class="mg_r_1">至</div>
                    <el-time-picker format="HH:mm" style="max-width: 150px" v-model="item.operatingTime[1]" placeholder="营业结束时间" />
                  </div>
                  <el-tooltip
                      class="box-item"
                      effect="dark"
                      content="删除"
                      placement="right">
                    <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="removeOperatingTime(index)"></v-icon>
                  </el-tooltip>
                </div>
                <div class="flex_left">
                  <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="addOperatingTime"></v-icon>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="车店小程序：">
              <el-input v-model="ruleForm.nonSelfOperatedLink" style="width: 250px;" placeholder="车店小程序"/>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`推荐官`">
          <template #container>
            <el-form-item label="姓名：" prop="">
              <el-input v-model="ruleForm.referralOfficer.name" style="width: 250px;" placeholder="推荐官姓名"/>
            </el-form-item>
            <el-form-item label="联系电话：" prop="">
              <el-input v-model="ruleForm.referralOfficer.phone" style="width: 250px;" placeholder="推荐官联系电话"/>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`商家认证类型`">
          <template #container>
            <el-form-item label="认证类型：">
              <div v-if="ruleForm?.certificationType === 'LEGAL_PERSON'">
                法人企业
              </div>
              <div v-else-if="ruleForm?.certificationType === 'NATURAL_PERSON'">
                自然人
              </div>
              <div v-else>
                未知
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`关联合作身份`">
          <template #container>
            <el-form-item label="选择合作身份">
              <div>
                <div>
                  <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in ruleForm.partnerStores" :key="`cachePartnerList${tag.storeName}-${tagIndex}`" closable type="success" @close="handleClosePartnerStoresTags(tagIndex)">
                    {{ tag.storeName }}
                  </el-tag>
                </div>
                <div class="flex_left">
                  <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleOpenPanel"></v-icon>
                  <div class="tips_default">
                    请先选择所属商家，再选择关联合作身份
                  </div>
                </div>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`服务提供方式`">
          <template #container>
            <el-form-item label="服务提供方式：" prop="serviceModeTypes">
              <el-checkbox-group v-model="ruleForm.serviceModeTypes">
                <el-checkbox label="到店" value="STORE" />
                <el-checkbox label="上门" value="VISIT" />
              </el-checkbox-group>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`服务和商品`">
          <template #container>
            <el-form-item label="服务和商品：" prop="businessTypes">
              <el-checkbox-group v-model="ruleForm.businessTypes">
                <el-checkbox label="车店" value="SALE_PHYSICAL_GOODS" />
                <el-checkbox label="整装保养" value="REPAIR_MAINTENANCE" />
              </el-checkbox-group>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`简介和详细介绍`">
          <template #container>
            <el-form-item label="简介：" prop="summary">
              <el-tabs
                  v-model="summaryTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input maxlength="34" v-model="ruleForm.summary" show-word-limit style="width: 250px;" placeholder="请用一句话介绍自己吧"/>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input maxlength="102" v-model="ruleForm.summaryEn" show-word-limit style="width: 250px;" placeholder="Please introduce yourself in one sentence"/>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item label="车店介绍：">
              <div>
                <el-tabs
                    v-model="descriptionTab"
                    type="card"
                    class="demo-tabs"
                >
                  <el-tab-pane label="中文" name="zh">
                    <YTEditor :ali-oss-path="'STORE_DESCRIPTION_IMAGE'" ref="YTEditorRef" :maxPic="10" :max-pic-size="6" :maxLength="1000" :reviewTxt="ruleForm.description" @change="handleDescriptionChange"></YTEditor>
                  </el-tab-pane>
                  <el-tab-pane label="English" name="en">
                    <YTEditor :ali-oss-path="'STORE_DESCRIPTION_EN_IMAGE'" ref="YTEditorEnRef" :maxPic="10" :max-pic-size="6" :maxLength="3000" :reviewTxt="ruleForm.descriptionEn" @change="handleDescriptionEnChange"></YTEditor>
                  </el-tab-pane>
                </el-tabs>
                <div class="tips_default">备注：用于显示在车店主页的介绍tag</div>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`负责人信息`">
          <template #container>
            <el-form-item label="负责人：" prop="contactName">
              <el-input v-model="ruleForm.contactName" style="width: 250px;" placeholder="负责人"/>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="ruleForm.phone" style="width: 250px;" placeholder="联系电话"/>
            </el-form-item>
            <el-form-item label="E-mail：" prop="contactEmail">
              <el-input v-model="ruleForm.contactEmail" style="width: 250px;" placeholder="E-mail"/>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`收件信息`">
          <template #container>
            <el-form-item label="收件人：">
              <el-input v-model="ruleForm.recipientInfo.recipientName" style="width: 250px;" placeholder="收件人"/>
            </el-form-item>
            <el-form-item label="联系电话：">
              <el-input maxlength="12" v-model="ruleForm.recipientInfo.recipientPhone" show-word-limit style="width: 250px;" placeholder="联系电话"/>
            </el-form-item>
            <el-form-item label="收件地址：">
              <YTAddress class="mg_r_1" :title="'收件地址'" :addressCode="recipientAddressCode" @select="handleSelectRecipientAddress"></YTAddress>
              <el-input v-model="ruleForm.recipientInfo.recipientAddress.addressDetail" style="width: 250px;" placeholder="收件地址"/>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`标签信息`">
          <template #container>
            <el-form-item label="标签：" prop="tagIdList">
              <div>
                <div>
                  <el-check-tag :disabled="ruleForm.tagIdList?.length >= 10 && !tag.checked" class="mg_r_1" v-for="(tag, index) in skillTags" :key="`skillTags${index}`" :checked="tag.checked" type="primary" @change="handleSkillTagsChange(tag)">
                    {{tag.tagName}}
                  </el-check-tag>
                </div>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`协助运营`" prop="assistsOperation">
          <template #container>
            <div class="flex_left mg_b_2">
              <div class="flex mg_r_2">
                <YTRadio
                    :show="ruleForm.assistsOperation === true"
                    @click="handleAssistStateChange(true)"
                ></YTRadio>
                <div class="mg_l_1">开通</div>
              </div>
              <div class="flex">
                <YTRadio
                    :show="ruleForm.assistsOperation === false"
                    @click="handleAssistStateChange(false)"
                ></YTRadio>
                <div class="mg_l_1">关闭</div>
              </div>
            </div>
          </template>
        </YTCard>
        <YTCard :title="`车店发现页推荐封面图信息`">
          <template #container>
            <el-form-item label="车店发现页推荐封面图：" prop="storeDiscoverCoverImage">
              <div>
                <BoxUpload ref="boxUploadStoreDiscoverCoverRef" :width="280" :height="280" :ali-oss-path="'STORE_DISCOVER_COVER_IMAGE'" @progress="loading = true" @success="handleStoreDiscoverCoverPicSuccess" @remove="handleStoreDiscoverCoverPicRemove" :limit="1"/>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`车店封面图信息`">
          <template #container>
            <el-form-item label="车店封面图：" prop="storeCoverImage">
              <div>
                <BoxUpload ref="boxUploadCoverRef" :width="181" :height="240" :ali-oss-path="'STORE_COVER_IMAGE'" @progress="loading = true" @success="handleCoverPicSuccess" @remove="handleCoverPicRemove" :limit="1"/>
                <div class="tips_default">备注：用于显示在车店列表和车店主页顶部背景图</div>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <YTCard :title="`车店主页相册`">
          <template #container>
            <el-form-item label="车店相册：" prop="photoList">
              <div>
                <BoxUpload ref="boxUploadPhotoRef" :width="375" :height="625" :ali-oss-path="'STORE_IMG_PATH'" @progress="loading = true" @success="handlePhotoPicSuccess" @remove="handlePhotoPicRemove" :limit="20"/>
              </div>
            </el-form-item>
          </template>
        </YTCard>
        <el-form-item label=" ">
          <div>
            <v-row>
              <v-col>
                <v-btn color="primary" @click="submit">保存</v-btn>
              </v-col>
            </v-row>
          </div>
        </el-form-item>
      </div>
    </el-form>
  </div>
  <YTPartnerSelectPanel :loading="partnerLoading" ref="YTPartnerSelectPanelRef" :selectedStores="ruleForm.partnerStores" :tableData="partnerList" @confirm="handlePanelConfirm"></YTPartnerSelectPanel>
</template>

<style lang="scss" scoped>
.create_container_box {
  width: 100%;
  height: 100%;
  .create_wrapper {
    background: #fff;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    padding-right: 20px;
  }
}
.add_member_tips_member {
  font-weight: 500;
  font-size: 14px;
  color: #684fa2;
}
</style>

